module.exports = __webpack_public_path__ + "static/media/brainy_band.e0c53375.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/brainy_band.png
// module id = 403
// module chunks = 0